import { useIsMerchant } from './useIsMerchant';
import { useIsMerchantParent } from './useIsMerchantParent';
import { useIsMultiMerchant } from './useIsMultiMerchant';
import { useIsVendor } from './useIsVendor';

/**
 * True when the signed-in user has exactly one own entity to act on and so
 * skips the Account Info entity picker entirely — a regular (non-parent,
 * non-multi) merchant "SubAccount" or any vendor/facility user. AccountInfoView
 * redirects these users straight to their own detail page because the picker is
 * pointless for them, so any "back to the picker" affordance on a detail page
 * is a no-op that just bounces through that redirect. Surfaces that render such
 * an affordance use this to hide it. Parent/multi merchants and super-admins DO
 * get the picker, so this is false for them.
 */
export function useBypassesEntityPicker(): boolean {
  const isMerchant = useIsMerchant();
  const isParent = useIsMerchantParent();
  const isMulti = useIsMultiMerchant();
  const isVendor = useIsVendor();
  const isRegularMerchant = isMerchant && !isParent && !isMulti;
  return isRegularMerchant || isVendor;
}
